<template>
  <div class="text-widget">
    <h2 v-if="title" class="text-widget__heading" v-html="title"/>
    <div
      v-if="description"
      v-html="description"
      class="text-widget__content"
    />
  </div>
</template>

<script>
export default {
  props: {
    description: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
  .text-widget {
    @include theme(color);
    @include text(medium);
    @include vertical-space((bottom: 2));

    @include media-up(lg) {
      @include nested-column-width(8, 9, lg);
    }

    &__content {
      /deep/ p:not(:last-child) {
        @include vertical-space((bottom: 1));
      }

      /deep/ a {
        @include reset-link;
        text-decoration: underline;
      }
    }

    &__heading {
      @include vertical-space((bottom: 1));
    }
  }
</style>



// WEBPACK FOOTER //
// src/containers/Details/TextWidget.vue